export const UPCOMING_EVENTS_TITLE = "Upcoming Events"
export const EVENTS_SUBHEADER = "Meals, days out and coffee mornings."